import { Pipe, PipeTransform } from '@angular/core'

declare const $localize: any

@Pipe({
  name: 'boolean',
  standalone: true,
})
export class BooleanPipe implements PipeTransform {
  /** Transform boolean into string
   * @param { boolean }
   * @returns { string }
   */
  public transform(value: boolean): string {
    switch (value) {
      case true:
        return $localize`:Label | Label true@@booleanPipeTrueLabel:Oui`

      case false:
        return $localize`:Label | Label false@@booleanPipeFalseLabel:Non`

      default:
        return ''
    }
  }
}
